<template>
    <div>
        <div v-if="!page_title" class="row">
            <h1 class="page-title page-title--category">Sales</h1>
        </div>
        <div v-else class="row">
            <h1 class="page-title page-title--single">
                <span>Sales</span> {{ page_title }}
            </h1>
        </div>

        <div class="row master-invoices-filter filter sales-filter">
            <form method="get">
                <div class="group-filter">
                    <div
                        class="form-field form-field__select form-field--search"
                    >
                        <div
                            class="form-field form-field__select"
                            style="max-width: 50%"
                        >
                            <label for="partner">Search</label>
                            <input
                                type="text"
                                v-model="searchRequest"
                                @input="search"
                                id="partner"
                            />
                        </div>
                    </div>
                    <div
                        class="checkbox"
                        style="flex-wrap: wrap; justify-content: flex-start"
                    >
                        <!-- ALL CHECKBOX -->
                        <div class="form-field checkbox-wrap">
                            <input
                                autocomplete="off"
                                type="checkbox"
                                id="filter_status_all"
                                value="all"
                                checked
                                :ref="'filter_status_all'"
                                @change="handleCheckAllStatus"
                            />
                            <label for="filter_status_all"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            All
                        </div>
                        <!-- end ALL CHECKBOX -->
                        <div
                            class="form-field checkbox-wrap"
                            v-for="filter in statuses"
                            :key="filter.id"
                        >
                            <input
                                type="checkbox"
                                :key="filter.id"
                                :id="`filter_status_${filter.id}`"
                                :value="filter.id"
                                autocomplete="off"
                                @change="checkboxValue"
                                :checked="
                                    selectedStatus.includes(
                                        (_status) => _status === filter.id
                                    )
                                "
                                :ref="`filter_status_${filter.id}`"
                                name="status[]"
                            />
                            <label :for="`filter_status_${filter.id}`"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            {{ filter.title }}
                        </div>
                    </div>
                </div>
                <div class="form-sales-column">
                    <div
                        class="form-field form-field__select form-field__select--master-invoices"
                    >
                        <label for="period">Sale Period</label>
                        <select
                            name="period"
                            id="period"
                            @change="setValue"
                            class="js-select-custom"
                        >
                            <option value="">All</option>
                            <option
                                v-for="period in periods"
                                :key="period"
                                :value="period"
                                v-text="formatDatePeriod(period)"
                            />
                        </select>
                    </div>
                    <button
                        @click="openColumnsModal"
                        type="button"
                        class="btn btn--gray"
                    >
                        Edit column view
                    </button>
                </div>
            </form>
        </div>

        <div
            class="row master-invoices-pagination master-invoices-pagination--top"
        ></div>
        <form method="get" action="/sales/master" ref="formInvoice">
            <div class="row master-invoices-table invoices-table">
                <!-- <div
                    v-if="master_invoice_available"
                    class="form-field form-field--button form-field--button-new"
                >
                    <button type="submit" class="btn btn--white">
                        Create master invoice
                    </button>
                </div> -->
                <div class="table-wrap">
                    <table class="table">
                        <thead>
                            <tr
                                v-if="
                                    current_columns &&
                                    current_columns.length > 0
                                "
                            >
                                <th v-if="items.length > 0">
                                    <BulkActions
                                        :onSelectAll="onSelectAllBulkItems"
                                        :menu_actions="bulkActionsList"
                                        :onCallAction="onCallAction"
                                    />
                                </th>
                                <th v-if="sale_data.relation === 'agency'"></th>
                                <th
                                    v-for="col_obj in current_columns
                                        .filter((c) => c.status === 'show')
                                        .sort(
                                            (a, b) => a.position - b.position
                                        )"
                                    v-bind:key="'col_table_th_' + col_obj.id"
                                    @click="sortData(col_obj.slug)"
                                    :class="{
                                        'has-total-value': col_obj.is_total,
                                    }"
                                >
                                    <span
                                        v-if="lastSort == col_obj.slug"
                                        :class="{
                                            'sort-icon--desc':
                                                descending &&
                                                lastSort == col_obj.slug,
                                            'has-total-value': col_obj.is_total,
                                        }"
                                        ><i class="icon icon-down-arrow"></i
                                    ></span>
                                    {{ col_obj.name }}
                                    <span
                                        v-if="col_obj.is_total"
                                        class="total"
                                        >{{
                                            totals_values[col_obj.slug] ?? 0
                                        }}</span
                                    >
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loading">
                                <td
                                    :colspan="
                                        sale_data.relation === 'agency'
                                            ? 11
                                            : 10
                                    "
                                >
                                    <clip-loader
                                        :loading="loading"
                                        :color="'#ec4657'"
                                        :size="'45px'"
                                    ></clip-loader>
                                </td>
                            </tr>
                            <tr v-else-if="!items.length && !loading">
                                <td
                                    :colspan="
                                        sale_data.relation === 'agency'
                                            ? 11
                                            : 10
                                    "
                                >
                                    <center>No data</center>
                                </td>
                            </tr>
                            <tr
                                v-else-if="searchRequest && filterItems.length"
                                v-for="item in filterItems"
                                :key="item.id"
                            >
                                <td
                                    v-if="items.length > 0"
                                    class="td-bulk-checkbox"
                                >
                                    <div class="form-field checkbox-wrap">
                                        <input
                                            type="checkbox"
                                            name="invoices[]"
                                            :value="item.id"
                                            :checked="
                                                bulkItemsSelected.includes(
                                                    item.id
                                                )
                                            "
                                            :id="`bulk_action_item-${item.id}`"
                                            @change="
                                                () => onSelectBulkItem(item.id)
                                            "
                                        />
                                        <label
                                            :for="`bulk_action_item-${item.id}`"
                                            ><i class="icon icon-checkmark"></i
                                        ></label>
                                    </div>
                                </td>
                                <!-- <td
                                    v-if="sale_data.relation === 'agency'"
                                    class="checkbox"
                                >
                                    <div class="form-field checkbox-wrap">
                                        <input
                                            type="checkbox"
                                            :id="`master_invoice_` + item.id"
                                            :value="item.id"
                                            name="master_invoice[]"
                                            @change="
                                                checkMasterInvoiceAvailability(
                                                    item
                                                )
                                            "
                                        />
                                        <label
                                            :for="`master_invoice_` + item.id"
                                        >
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                    </div>
                                </td> -->
                                <td
                                    v-for="_col in current_columns.filter(
                                        (c) => c.status === 'show'
                                    )"
                                    v-bind:key="'col_table_sales_' + _col.id"
                                >
                                    <a
                                        v-if="
                                            _col.is_link && item[_col.slug].url
                                        "
                                        :href="item[_col.slug].url"
                                        :style="
                                            item.status == 'Overdue'
                                                ? 'color:red'
                                                : ''
                                        "
                                        >{{ item[_col.slug].name }}</a
                                    >
                                    <button
                                        v-else-if="_col.slug === 'action'"
                                        class="btn btn--icon"
                                        @click="deletePartner(item.id)"
                                        type="button"
                                    >
                                        <i class="icon icon-trash"></i>
                                    </button>
                                    <p
                                        v-else
                                        :class="
                                            !item[_col.slug] ||
                                            item[_col.slug] === '-' ||
                                            item[_col.slug] <= 0
                                                ? 'color-of-null'
                                                : ''
                                        "
                                    >
                                        {{ item[_col.slug] || "-" }}
                                    </p>
                                </td>
                            </tr>

                            <tr
                                v-else-if="
                                    !filterItems.length &&
                                    searchRequest.length >= 3
                                "
                            >
                                <td
                                    :colspan="
                                        sale_data.relation === 'agency'
                                            ? 11
                                            : 10
                                    "
                                >
                                    <center>No data</center>
                                </td>
                            </tr>

                            <tr v-else v-for="item in items" :key="item.id">
                                <td
                                    v-if="items.length > 0"
                                    class="td-bulk-checkbox"
                                >
                                    <div class="form-field checkbox-wrap">
                                        <input
                                            type="checkbox"
                                            name="invoices[]"
                                            :value="item.id"
                                            :checked="
                                                bulkItemsSelected.includes(
                                                    item.id
                                                )
                                            "
                                            :id="`bulk_action_item-${item.id}`"
                                            @change="
                                                () => onSelectBulkItem(item.id)
                                            "
                                        />
                                        <label
                                            :for="`bulk_action_item-${item.id}`"
                                            ><i class="icon icon-checkmark"></i
                                        ></label>
                                    </div>
                                </td>
                                <!-- <td
                                    v-if="sale_data.relation === 'agency'"
                                    class="checkbox"
                                >
                                    <div class="form-field checkbox-wrap">
                                        <input
                                            type="checkbox"
                                            :id="`master_invoice_` + item.id"
                                            :value="item.id"
                                            name="master_invoice[]"
                                            @change="
                                                checkMasterInvoiceAvailability(
                                                    item
                                                )
                                            "
                                        />
                                        <label
                                            :for="`master_invoice_` + item.id"
                                        >
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                    </div>
                                </td> -->
                                <td
                                    v-for="_col in current_columns.filter(
                                        (c) => c.status === 'show'
                                    )"
                                    v-bind:key="'col_table_sales_' + _col.id"
                                >
                                    <a
                                        v-if="
                                            _col.is_link && item[_col.slug].url
                                        "
                                        :href="item[_col.slug].url"
                                        :style="
                                            item.status == 'Overdue'
                                                ? 'color:red'
                                                : ''
                                        "
                                        >{{ item[_col.slug].name }}</a
                                    >
                                    <button
                                        v-else-if="_col.slug === 'action'"
                                        class="btn btn--icon"
                                        @click="deletePartner(item.id)"
                                        type="button"
                                    >
                                        <i class="icon icon-trash"></i>
                                    </button>
                                    <p
                                        v-else
                                        :class="
                                            !item[_col.slug] ||
                                            item[_col.slug] === '-' ||
                                            item[_col.slug] <= 0
                                                ? 'color-of-null'
                                                : ''
                                        "
                                    >
                                        {{ item[_col.slug] || "-" }}
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </form>

        <ColumnModal
            :is_show="showModalColumns"
            :__columns="current_columns"
            :selectColumn="selectColumn"
            :closeModal="closeModal"
            :selected_col="selected_col"
            v-if="showModalColumns"
        ></ColumnModal>

        <div class="row master-invoices-pagination jus-c--right"></div>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";
import * as sortArray from "../../parts/sort-array";
import ColumnModal from "../ColumnModal/index.vue";
import BulkActions from "../BulkActions/index.vue";

export default {
    name: "Sales",
    props: [
        "sale_data",
        "page_title",
        "agencies",
        "statuses",
        "periods",
        "columns",
        "actions",
    ],
    components: {
        ClipLoader,
        ColumnModal,
        BulkActions,
    },
    data() {
        return {
            selectedSale: null,
            filterItems: [],
            selectedStatus: [],
            selectedItems: [],
            agency: null,
            period: null,
            loading: false,
            items: [],
            descending: false,
            searchRequest: "",
            //master_invoice_available: false,
            lastSort: "id",
            showModalColumns: false,
            selected_col: null,
            current_columns: [],
            filter_columns: [],
            totals_values: {},
            bulkItemsSelected: [],
        };
    },

    mounted() {
        this.current_columns = JSON.parse(JSON.stringify(this.columns));

        console.log("actions", this.actions)

        this.fetchData();
    },

    computed: {
        bulkActionsList: function () {
            if (this.actions.length) {
                return this.actions.map((action) => {
                    return {
                        name: action.label,
                        url: action.url,
                        validation: action.validation,
                        is_need_submit: action.is_need_submit,
                    };
                });
            }

            return [];
        },
    },

    methods: {
        // checkMasterInvoiceAvailability(item) {
        //     if (this.sale_data.relation === "agency") {
        //         let isExist = this.selectedItems.find((o, i) => {
        //             if (o.id === item.id) {
        //                 this.selectedItems.splice(i, 1);
        //                 return true; // stop searching
        //             }
        //         });
        //         if (!isExist) {
        //             this.selectedItems.push(item);
        //         }
        //         if (this.selectedItems.length > 0) {
        //             this.selectedItems.find((o) => {
        //                 if (o.status !== "Approved") {
        //                     this.master_invoice_available = false;
        //                     return true;
        //                 } else {
        //                     this.master_invoice_available = true;
        //                 }
        //             });
        //         } else {
        //             this.master_invoice_available = false;
        //         }
        //     }
        // },
        /*changeSelect(e) {
            const id = e.id;

            if (id) {
                this.selectedSale = id;
                this.filterData(id);
            } else {
                this.selectedSale = null;
                this.filterItems = [];
            }
        },*/
        setValue(e) {
            const name = e.target.name;
            const value = e.target.value;

            this[name] = value;

            this.fetchData();
        },
        formatDatePeriod(date) {
            const options = { year: "numeric", month: "long" };
            const _date = new Date(date);

            return _date.toLocaleDateString("en-GB", options);
        },
        checkboxValue(e) {
            if (e.target.checked) {
                this.selectedStatus.push(e.target.value);
                if (this.$refs.filter_status_all.checked) {
                    this.$refs.filter_status_all.click();
                }
            } else {
                this.selectedStatus = this.selectedStatus.filter(
                    (i) => i != e.target.value
                );
            }

            this.fetchData();
        },

        handleCheckAllStatus(e) {
            if (e.target.checked) {
                this.selectedStatus = [];
                this.statuses.forEach((filter) => {
                    const _checkbox =
                        this.$refs[`filter_status_${filter.id}`][0];
                    if (_checkbox.checked) {
                        _checkbox.click();
                    }
                });
            }
        },

        fetchData() {
            this.loading = true;

            axios
                .post("/sales/getList", {
                    sale_data: this.sale_data,
                    status: this.selectedStatus,
                    period: this.period,
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.hasOwnProperty("totals")) {
                        this.totals_values = res.data.totals;
                    }
                    if (res.data.hasOwnProperty("all") && res.data.all.length) {
                        this.items = this.reformatDataByColumns(res.data.all);
                        if (this.searchRequest.length >= 3) {
                            this.search();
                        }
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },

        /*filterData(id = null) {
            this.filterItems = this.items.filter((item) => item.id === id);
        },*/
        search() {
            if (this.searchRequest.length >= 3) {
                this.filterItems = this.reformatDataByColumns(
                    this.items
                ).filter(
                    (item) =>
                        item.sale_number.name
                            .toLowerCase()
                            .includes(this.searchRequest.toLowerCase()) ||
                        item.agency.name
                            .toLowerCase()
                            .includes(this.searchRequest.toLowerCase()) ||
                        item.brand.name
                            .toLowerCase()
                            .includes(this.searchRequest.toLowerCase()) ||
                        item.deal.name
                            .toLowerCase()
                            .includes(this.searchRequest.toLowerCase())
                );
            }
        },
        sortData(sortBy) {
            let self = this;
            if (self.lastSort !== sortBy) self.descending = false;
            self.lastSort = sortBy;
            switch (sortBy) {
                case "sale_number":
                    self.items = self.items.sort(
                        sortArray.sortText("id", self.descending)
                    );
                    break;
                case "invoice_number":
                    self.items = self.items.sort(
                        sortArray.sortText("id", self.descending)
                    );
                    break;
                case "sales_period":
                    self.items = self.items.sort(
                        sortArray.sortDate("sales_period", self.descending)
                    );
                    break;
                case "status":
                    self.items = self.items.sort(
                        sortArray.sortText("status", self.descending, (a) =>
                            a.toUpperCase()
                        )
                    );
                    break;
                case "brand":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "brand",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "agency":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "agency",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "deal":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "deal",
                            self.descending,
                            (a) => a.toLowerCase(),
                            "name"
                        )
                    );
                    break;
                case "invoiced":
                    self.items = self.items.sort(
                        sortArray.sortMoney("invoiced", self.descending)
                    );
                    break;
                case "collected":
                    self.items = self.items.sort(
                        sortArray.sortMoney("collected", self.descending)
                    );
                    break;
                case "commission_owed":
                    self.items = self.items.sort(
                        sortArray.sortMoney("commission_owed", self.descending)
                    );
                    break;
            }
            self.descending = !self.descending;
        },

        // Modal columns
        reformatDataByColumns(__items = []) {
            try {
                if (__items.length >= 1) {
                    const newFormatData = [];
                    if (this.current_columns.length >= 1) {
                        __items.forEach((item) => {
                            const tempObj = {};
                            this.current_columns
                                .sort((a, b) => a.position - b.position)
                                .forEach((c) => {
                                    if (c.status === "hidden") {
                                        return;
                                    }
                                    tempObj[`${c.slug}`] = item[c.slug];
                                    tempObj["brand"] = item["brand"];
                                    tempObj["id"] = item["id"];
                                    tempObj["status_id"] = item["status_id"];
                                });

                            newFormatData.push(tempObj);
                        });
                        return newFormatData;
                    }
                }

                return [];
            } catch (err) {
                console.error("reformatDataByColumns error", err);
            }
        },
        openColumnsModal() {
            this.showModalColumns = true;
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        },
        async closeModal(items = []) {
            await axios
                .post("/sales/updateColumns", {
                    columns: items,
                })
                .then(() => {
                    this.showModalColumns = false;
                    this.current_columns.length = 0;
                    this.current_columns = JSON.parse(JSON.stringify(items));
                    document.querySelector("html").style = "";
                    document.querySelector("body").style = "";
                })
                .catch((err) => {
                    console.error("Axios update columns error", err);
                });
        },
        selectColumn(col) {
            this.selected_col = col;
        },
        onSelectBulkItem(id = null) {
            if (id) {
                if (this.bulkItemsSelected.includes(id)) {
                    this.bulkItemsSelected = this.bulkItemsSelected.filter(
                        (item) => item !== id
                    );
                } else {
                    this.bulkItemsSelected = [...this.bulkItemsSelected, id];
                }
            }
        },
        onSelectAllBulkItems(e) {
            if (e.target.checked) {
                if (this.searchRequest && this.filterItems.length) {
                    this.bulkItemsSelected = [
                        ...new Set(this.filterItems.map((item) => item.id)),
                    ];
                } else if (this.items.length) {
                    this.bulkItemsSelected = [
                        ...new Set(this.items.map((item) => item.id)),
                    ];
                } else {
                    this.bulkItemsSelected = [];
                }

                return;
            }

            this.bulkItemsSelected = [];
        },

        // Actions for bulk
        async onCallAction(url, validation, is_need_submit = false) {
            this.loading = true;
            try {
                if (!this.bulkItemsSelected.length) {
                    this.$toast.error(
                        "No option selected. Please select at least one item from the list"
                    );
                    return;
                }

                let isAvailableStatus = true;

                this.bulkItemsSelected.forEach((itemId) => {
                    const __sale = this.items.find((i) => i.id === itemId);

                    if (__sale) {
                        if (
                            !validation.status_id.some(
                                (i) => i === __sale.status_id
                            )
                        ) {
                            isAvailableStatus = false;
                        }
                    }
                });

                if (!isAvailableStatus) {
                    this.$toast.error(
                        "Some of the selected options have the wrong status"
                    );
                    return;
                }

                if (is_need_submit) {
                    this.$refs.formInvoice.action = url;

                    this.$refs.formInvoice.submit();

                    return;
                }

                await axios
                    .post(url, {
                        invoices: this.bulkItemsSelected,
                    })
                    .then(() => {
                        this.$toast.success("Successfully updated");
                        this.fetchData();
                    })
                    .catch((err) => {
                        this.$toast.error(
                            "Something went wrong. Details in console"
                        );
                        console.log("Action error", err);
                    });
            } catch (err) {
                console.error("onApproveItems", err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
